import { $t } from '@/utils/languageAuto';
import { __decorate, __extends } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import InboundDeliveryOrderCharge from '@/views/components/inboundDeliveryOrderCharge/index.vue';
import Breadcrumb from '@/components/breadcrumb/index.vue';

var ChargesDetail = function (_super) {
  __extends(ChargesDetail, _super);

  function ChargesDetail() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.breadcrumbData = [{
      title: _this.t('货运单详情'),
      routerName: 'DeliveryOrderDetailPage',
      query: {
        code: _this.$route.query.code,
        order_type: _this.$route.query.order_type,
        name: 'DeliveryOrderPage'
      }
    }, {
      title: _this.t('海外仓入库费用明细')
    }];
    return _this;
  }

  ChargesDetail = __decorate([Component({
    components: {
      Breadcrumb: Breadcrumb,
      InboundDeliveryOrderCharge: InboundDeliveryOrderCharge
    }
  })], ChargesDetail);
  return ChargesDetail;
}(Vue);

export default ChargesDetail;